import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './RENT_Unit_Profile.css';

const RENT_Unit_Profile = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"RENT_UNIT_PROFILE",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	RENT_UNIT_PROFILE:-1
  });


  const [RENT_UNIT_PROFILE, setRENT_UNIT_PROFILE] = React.useState(null);
  const [RENT_UNIT_PROFILE_D, setRENT_UNIT_PROFILE_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Unit Profile');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/RENT_Unit_Profile',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewRENT_UNIT_PROFILE(clientInfo,"OpenNew");

		navigate('/RENT_Unit_Profile',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutRENT_UNIT_PROFILE(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostRENT_UNIT_PROFILE(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewRENT_UNIT_PROFILE(clientInfo,"OpenNew");
		}
		navigate('/RENT_Unit_Profile',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
		if(Temp_Data2.status!="New"){
			handleDeleteRENT_UNIT_PROFILE(Temp_Data2);
			navigate('/RENT_Unit_Profile#New',{replace:true});
		} 
		else 
			navigate('/RENT_Unit_Profile',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/RENT_Unit_Profile',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!RENT_UNIT_PROFILE) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [RENT_UNIT_PROFILE]) ;


  
  
  var Ids = [];
  for(var Ele in RENT_UNIT_PROFILE){
	  for(var Sec in RENT_UNIT_PROFILE[Ele]){
		if(Sec == "id")
			Ids.push(RENT_UNIT_PROFILE[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(RENT_UNIT_PROFILE[Ele]["status"]);
		else if(Array.isArray(RENT_UNIT_PROFILE[Ele][Sec]))
			  for(var Row in RENT_UNIT_PROFILE[Ele][Sec])  // Convert to RENT_UNIT_PROFILE[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in RENT_UNIT_PROFILE[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["RENT_UNIT_PROFILE"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewRENT_UNIT_PROFILE(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_UNIT_PROFILE`).then((response1) => {
		if(!RENT_UNIT_PROFILE) 
			setRENT_UNIT_PROFILE(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_UNIT_PROFILE_D`).then((response2) => {
			setRENT_UNIT_PROFILE_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddRENT_UNIT_PROFILE_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewRENT_UNIT_PROFILE = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_UNIT_PROFILE/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setRENT_UNIT_PROFILE(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataRENT_UNIT_PROFILE = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_UNIT_PROFILE/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutRENT_UNIT_PROFILE = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_UNIT_PROFILE/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostRENT_UNIT_PROFILE = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_UNIT_PROFILE', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteRENT_UNIT_PROFILE = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_UNIT_PROFILE', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["1"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("1","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["1"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("1","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["1"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("1","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["1"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("1","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_0"]=value;
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_0",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["2"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("2","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["3"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("3","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["3"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("3","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["3"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_2"]=value;
	Form_Data_onChange("3","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_2",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  


const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["4"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_0"]=value;
	Form_Data_onChange("4","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_0",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["4"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1"]=value;
	Form_Data_onChange("4","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1",value,Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
  }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["5"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_0"]=value;
	Form_Data_onChange("5","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_0",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  

  
      
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0"]=value ? true : false; // optionally just use boolean
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  



const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_1"]=value;
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_1",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  


const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_2"]=value;
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_2",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_9_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_9"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_9"]=value;
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_9",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  


const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_10_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_10"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_10"]=value;
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_10",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  


const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_11_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_11"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_11"]=value;
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_11",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  


const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_12_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_12"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_12"]=value;
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_12",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19"]=value;
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19",value,Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
  }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["8"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("8","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  

const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_0",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
  }; 
  

    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  
    
const RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
	Temp_Data["9"]["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4"]=value;
	//handleAddRENT_UNIT_PROFILE(Temp_Data,App_Data['RENT_UNIT_PROFILE']);
	Form_Data_onChange("9","RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4",value,Temp_Data);
 	//handleLastDataRENT_UNIT_PROFILE(Temp_Data);
    setRENT_UNIT_PROFILE(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!RENT_UNIT_PROFILE) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedRENT_UNIT_PROFILE =JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
  updatedRENT_UNIT_PROFILE[Sec] = [...updatedRENT_UNIT_PROFILE[Sec], newRow];
  setRENT_UNIT_PROFILE(updatedRENT_UNIT_PROFILE);
};

const handleDeleteRow = (sec,index) => {
  const updatedRENT_UNIT_PROFILE = JSON.parse(JSON.stringify(RENT_UNIT_PROFILE));
  updatedRENT_UNIT_PROFILE[sec].splice(index, 1);
  setRENT_UNIT_PROFILE(updatedRENT_UNIT_PROFILE);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Rental Income Unit Profile`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Income Unit Profile ID`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Unit Profile ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0" type="text" className="form-control" placeholder="RENT Unit Profile ID" value={RENT_UNIT_PROFILE["1"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Unit Profile ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1" type="text" className="form-control" placeholder="Asset ID" value={RENT_UNIT_PROFILE["1"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Unit ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2" type="text" className="form-control" placeholder="Unit ID" value={RENT_UNIT_PROFILE["1"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Unit ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Unit Label`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3" type="text" className="form-control" placeholder="Unit Label" value={RENT_UNIT_PROFILE["1"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Unit Label`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Unit Type`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Unit Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_0"  value={RENT_UNIT_PROFILE["2"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_0`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_0_Change} className="form-control" name="Unit Type"  >
						  <option value="Studio">Studio</option>
						  <option value="One Bedroom">One Bedroom</option>
						  <option value="Two Bedroom">Two Bedroom</option>
						  <option value="Three Bedroom">Three Bedroom</option>
						  <option value="Four Plus Bedroom">Four Plus Bedroom</option>
						  <option value="Commercial Unit">Commercial Unit</option>
						  <option value="Storage">Storage</option>
						  <option value="Parking">Parking</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Unit Type
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Bedrooms Count`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1" type="text" className="form-control" placeholder="Bedrooms Count" value={RENT_UNIT_PROFILE["2"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Bedrooms Count`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Bathrooms Count`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2" type="text" className="form-control" placeholder="Bathrooms Count" value={RENT_UNIT_PROFILE["2"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Bathrooms Count`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Square Feet`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3" type="text" className="form-control" placeholder="Square Feet" value={RENT_UNIT_PROFILE["2"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Square Feet`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Market Rent USD`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Market Rent USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0" type="text" className="form-control" placeholder="Market Rent USD" value={RENT_UNIT_PROFILE["3"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Market Rent USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Current Lease ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1" type="text" className="form-control" placeholder="Current Lease ID" value={RENT_UNIT_PROFILE["3"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Current Lease ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Occupancy Status RENT`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_2"  value={RENT_UNIT_PROFILE["3"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_2`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_3_2_Change} className="form-control" name="Occupancy Status RENT"  >
						  <option value="Vacant">Vacant</option>
						  <option value="Occupied">Occupied</option>
						  <option value="Notice Given">Notice Given</option>
						  <option value="Under Turnover">Under Turnover</option>
						  <option value="Unavailable">Unavailable</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Occupancy Status RENT
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Rental Unit Condition Rating`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Unit Condition Rating RENT`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_0"  value={RENT_UNIT_PROFILE["4"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_0`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_0_Change} className="form-control" name="Unit Condition Rating RENT"  >
						  <option value="Excellent">Excellent</option>
						  <option value="Good">Good</option>
						  <option value="Fair">Fair</option>
						  <option value="Poor">Poor</option>
						  <option value="Critical">Critical</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Unit Condition Rating RENT
				     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Last Inspection Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1" type="date"  value={RENT_UNIT_PROFILE["4"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1`]} 
							onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1_Change} style={{ borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_4_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Last Inspection Date
					  </div>
				  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Unit Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Unit Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_0"  value={RENT_UNIT_PROFILE["5"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_0`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_5_0_Change} className="form-control" name="Unit Status"  >
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Under Repair">Under Repair</option>
						  <option value="Removed">Removed</option>
						  <option value="Pending Review">Pending Review</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Unit Status
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Map Display Enabled`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_SECTION" className="row">
			                 {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Map Display Enabled`)} <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0_Change} 
					  checked={RENT_UNIT_PROFILE?.["8"]?.["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0"] === "true" || RENT_UNIT_PROFILE?.["8"]?.["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_0"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Public Visibility`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_1"  value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_1`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_1_Change} className="form-control" name="Map Public Visibility"  >
						  <option value="Exact Public Boundary">Exact Public Boundary</option>
						  <option value="Approximate Public Boundary">Approximate Public Boundary</option>
						  <option value="Hidden From Public">Hidden From Public</option>
						  <option value="Investor Only After Login">Investor Only After Login</option>
						  <option value="Accredited / Approved Investor Only">Accredited / Approved Investor Only</option>
						  <option value="Internal Only">Internal Only</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Public Visibility
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Map Listing Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_2"  value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_2`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_2_Change} className="form-control" name="Map Listing Status"  >
						  <option value="Not Listed">Not Listed</option>
						  <option value="Pre-Listing Draft">Pre-Listing Draft</option>
						  <option value="Preview Only">Preview Only</option>
						  <option value="Listed - Not Investable">Listed - Not Investable</option>
						  <option value="Listed - Investment Open">Listed - Investment Open</option>
						  <option value="Paused">Paused</option>
						  <option value="Closed">Closed</option>
						  <option value="Archived">Archived</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Map Listing Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Map Place ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3" type="text" className="form-control" placeholder="Google Map Place ID" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Google Map Place ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Google Maps URL`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4" type="text" className="form-control" placeholder="Google Maps URL" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Google Maps URL`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '240ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Display Address`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5" type="text" className="form-control" placeholder="Map Display Address" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '240ch' }}>
						 {t(`Enter Map Display Address`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Latitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6" type="text" className="form-control" placeholder="Map Center Latitude" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_6"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Latitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Center Longitude`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7" type="text" className="form-control" placeholder="Map Center Longitude" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_7"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Map Center Longitude`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Default Zoom`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8" type="text" className="form-control" placeholder="Map Default Zoom" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_8"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Map Default Zoom`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_9"  value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_9`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_9_Change} className="form-control" name="Boundary Type"  >
						  <option value="Point Only">Point Only</option>
						  <option value="Parcel Boundary">Parcel Boundary</option>
						  <option value="Building Footprint">Building Footprint</option>
						  <option value="Unit Boundary">Unit Boundary</option>
						  <option value="Multi-Parcel Boundary">Multi-Parcel Boundary</option>
						  <option value="Multi-Building Boundary">Multi-Building Boundary</option>
						  <option value="Development Site Boundary">Development Site Boundary</option>
						  <option value="Easement / Access Boundary">Easement / Access Boundary</option>
						  <option value="Estimated Boundary">Estimated Boundary</option>
						  <option value="Confidential Boundary">Confidential Boundary</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Source`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_10"  value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_10`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_10_Change} className="form-control" name="Boundary Source"  >
						  <option value="Google Maps">Google Maps</option>
						  <option value="Manual Pin">Manual Pin</option>
						  <option value="County GIS Parcel">County GIS Parcel</option>
						  <option value="Assessor Parcel Map">Assessor Parcel Map</option>
						  <option value="Survey">Survey</option>
						  <option value="Title Report">Title Report</option>
						  <option value="Deed Legal Description">Deed Legal Description</option>
						  <option value="KML / KMZ Upload">KML / KMZ Upload</option>
						  <option value="GeoJSON Upload">GeoJSON Upload</option>
						  <option value="Broker / Seller Provided">Broker / Seller Provided</option>
						  <option value="Auction Source">Auction Source</option>
						  <option value="Unknown">Unknown</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Source
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Verification Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_11"  value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_11`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_11_Change} className="form-control" name="Boundary Verification Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Unverified">Unverified</option>
						  <option value="Auto-Geocoded">Auto-Geocoded</option>
						  <option value="Manually Drawn">Manually Drawn</option>
						  <option value="Needs Review">Needs Review</option>
						  <option value="Verified by Platform">Verified by Platform</option>
						  <option value="Verified by Survey">Verified by Survey</option>
						  <option value="Verified by Title / County Record">Verified by Title / County Record</option>
						  <option value="Disputed">Disputed</option>
						  <option value="Hidden / Confidential">Hidden / Confidential</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Verification Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Boundary Geometry Format`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_12"  value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_12`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_12_Change} className="form-control" name="Boundary Geometry Format"  >
						  <option value="Point">Point</option>
						  <option value="Bounding Box">Bounding Box</option>
						  <option value="Polygon GeoJSON">Polygon GeoJSON</option>
						  <option value="MultiPolygon GeoJSON">MultiPolygon GeoJSON</option>
						  <option value="FeatureCollection GeoJSON">FeatureCollection GeoJSON</option>
						  <option value="WKT">WKT</option>
						  <option value="KML / KMZ">KML / KMZ</option>
						  <option value="Encoded Polyline">Encoded Polyline</option>
						  <option value="Image Overlay Reference">Image Overlay Reference</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Boundary Geometry Format
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary GeoJSON`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13" type="text" className="form-control" placeholder="Boundary GeoJSON" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_13"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary GeoJSON`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '12000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary WKT`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14" type="text" className="form-control" placeholder="Boundary WKT" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_14"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '12000ch' }}>
						 {t(`Enter Boundary WKT`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '500ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Bounding Box`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15" type="text" className="form-control" placeholder="Boundary Bounding Box" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_15"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '500ch' }}>
						 {t(`Enter Boundary Bounding Box`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Parcel ID List`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16" type="text" className="form-control" placeholder="Parcel ID List" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_16"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Parcel ID List`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Legal Description Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17" type="text" className="form-control" placeholder="Legal Description Link" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_17"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Legal Description Link`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Survey Document Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18" type="text" className="form-control" placeholder="Survey Document Link" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_18"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Survey Document Link`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Boundary Last Verified Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19" type="date"  value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19`]} 
							onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19_Change} style={{ borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_19"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Boundary Last Verified Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Boundary Verified By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20" type="text" className="form-control" placeholder="Boundary Verified By" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_20"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Boundary Verified By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '1000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Map Disclaimer`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21" type="text" className="form-control" placeholder="Map Disclaimer" value={RENT_UNIT_PROFILE["8"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_8_21"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '1000ch' }}>
						 {t(`Enter Map Disclaimer`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_0"  value={RENT_UNIT_PROFILE["9"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_0`]} onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1" type="text" className="form-control" placeholder="Created By" value={RENT_UNIT_PROFILE["9"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2" type="text" className="form-control" placeholder="Created At" value={RENT_UNIT_PROFILE["9"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3" type="text" className="form-control" placeholder="Updated By" value={RENT_UNIT_PROFILE["9"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4" type="text" className="form-control" placeholder="Updated At" value={RENT_UNIT_PROFILE["9"][`RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4`]} 
						onChange={RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_01_ASSET_OWNER_SPONSOR_ASSET_SETUP_RENT_UNIT_PROFILE_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default RENT_Unit_Profile;  